import { render, staticRenderFns } from "./BlockEditorPage.vue?vue&type=template&id=c220b1da&scoped=true"
import script from "./BlockEditorPage.vue?vue&type=script&lang=js"
export * from "./BlockEditorPage.vue?vue&type=script&lang=js"
import style0 from "./BlockEditorPage.vue?vue&type=style&index=0&id=c220b1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c220b1da",
  null
  
)

export default component.exports